__webpack_require__.p = "https://storage.atlasplan.com/public/frontend/20231122_181509_production/assets/";